import { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";
import { format } from "date-fns";
import { Link } from "react-router-dom";

interface PollEntry {
  program_item_id: string | null;
  program_title: string | null;
  start_time: string;
  end_time: string;
  location: string | null;
  trip_id: string;
  trip_name: string;
  poll_answer_deadline: string | null;
  poll_target_info: string | null;
  poll_allow_abstain: boolean | null;
  user_id: string | null;
}

export default function PollUserView() {
  const [polls, setPolls] = useState<PollEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPolls = async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();

      if (!user) {
        setLoading(false);
        return;
      }

      const { data, error } = await supabase
        .from("program_poll_user_view")
        .select("*")
        .eq("user_id", user.id)
        .order("start_time", { ascending: true });

      if (!error && data) {
        setPolls(data as PollEntry[]);
      }

      setLoading(false);
    };

    loadPolls();
  }, []);

  if (loading) {
    return <p className="text-gray-500 text-sm">⏳ Lade Umfragen…</p>;
  }

  if (polls.length === 0) {
    return <h3></h3>;
  }

  return (
    <div className="space-y-4">
      <h3 className="text-xl font-bold mb-4">🗳 Deine offenen Umfragen</h3>
      {polls.map((poll) => (
        <div
          key={poll.program_item_id}
          className="border p-4 rounded shadow-sm bg-white flex flex-col sm:flex-row sm:justify-between gap-2"
        >
          <div>
            <h3 className="text-lg font-semibold text-indigo-700">
              {poll.program_title}
            </h3>
            <p className="text-sm text-gray-700">
              📍 {poll.location ?? "Ort nicht definiert"}
            </p>
            <p className="text-sm text-gray-700">
              🕓 {format(new Date(poll.start_time), "dd.MM.yyyy HH:mm")} –{" "}
              {format(new Date(poll.end_time), "HH:mm")}
            </p>
            <p className="text-sm text-gray-500 italic">
              🔗 Reise: {poll.trip_name}
            </p>
            {poll.poll_answer_deadline && (
              <p className="text-sm text-red-600 mt-1">
                🕔 Frist:{" "}
                {format(
                  new Date(poll.poll_answer_deadline),
                  "dd.MM.yyyy HH:mm"
                )}
              </p>
            )}
            {poll.poll_target_info && (
              <p className="text-sm text-gray-600 mt-1">
                🎯 Hinweis: {poll.poll_target_info}
              </p>
            )}
          </div>

          <div className="flex items-center sm:items-start justify-end sm:justify-center">
            <Link
              to={`/trip/${poll.trip_id}/poll/${poll.program_item_id}`}
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 text-sm"
            >
              Umfrage beantworten
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
}
